export interface Category {
  id: string;
  slug: string;
  name: string;
  nameKey: string;
  description: string;
  count: number;
}

export const categories: Category[] = [
  {
    id: '1',
    slug: 'forbidden-love',
    name: '禁忌爱情',
    nameKey: 'category.forbidden_love',
    description: '探讨被社会规范所禁止的爱情关系，展现人性中最深层的情感渴望与道德边界的碰撞',
    count: 5,
  },
  {
    id: '2',
    slug: 'social-critique',
    name: '社会批判',
    nameKey: 'category.social_critique',
    description: '以伦理议题为切入点，对韩国社会中的阶级矛盾、性别不平等和权力结构进行深刻反思',
    count: 3,
  },
  {
    id: '3',
    slug: 'thriller',
    name: '悬疑惊悚',
    nameKey: 'category.thriller',
    description: '将情欲元素与悬疑叙事相结合，创造令人窒息的观影体验和心理张力',
    count: 1,
  },
  {
    id: '4',
    slug: 'classic',
    name: '经典回顾',
    nameKey: 'category.classic',
    description: '回顾韩国伦理电影史上的经典之作，重新审视这些作品在当下的艺术价值和文化意义',
    count: 3,
  },
  {
    id: '5',
    slug: 'latest-release',
    name: '最新上映',
    nameKey: 'category.latest_release',
    description: '追踪最新上映和即将上映的韩国伦理电影，提供第一时间的观影指南和深度解读',
    count: 0,
  },
];

export const getCategoryBySlug = (slug: string): Category | undefined => categories.find(c => c.slug === slug);